<script setup lang="ts">
  import { HolderInfoWidget } from '@/widgets'
</script>

<template>
  <HolderInfoWidget />
</template>
